import { uploadData } from 'aws-amplify/storage';
import { v4 as uuidv4 } from 'uuid';
import { getFfdUrl } from 'shared/api/ffdClient';

export const submitWaterTightCheck = async (
  yamlConfig: string,
  authToken: string,
  cognitoId: string,
): Promise<void> => {
  // Generate random file names
  const yamlFileName = `${uuidv4()}.yml`;
  const yamlFilePath = `from-web-app/${cognitoId}/geometry-check-config/${yamlFileName}`;

  // Upload YAML file to S3
  try {
    const task = uploadData({
      path: yamlFilePath,
      data: yamlConfig
    });
    await task.result;
  } catch (error) {
    alert("Failed to upload .YAML to the server.");
  }

  // Send API request using uploaded YAML file
  try {
    const response = await fetch(getFfdUrl("/stl-check/start"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken,
      },
      body: JSON.stringify({ yamlFilePath }),
    });

    const status = response.status;
    const data = await response.json();
    if (status === 200) {
      alert(data.text);
    } else if (status === 422) {
      alert("NOT WATER TIGHT!\n" + data.text);
    } else {
      alert("ERROR!\n" + data.text);
    }
  } catch (error: any) {
    console.error(error);
    alert('通信エラー: 認証の有効期限やネットワーク状態を確認してください。');
  }
};
